export enum TranscriptionEvent {
  // Client -> Server events
  StartTranscription = 'start-transcription',
  AudioData = 'audio-data',
  PauseTranscription = 'pause-transcription',
  CompleteTranscription = 'complete-transcription',
  StopTranscription = 'stop-transcription',
  UpdateSpeakerName = 'update-speaker-name',
  MapInternalSpeaker = 'map-internal-speaker',
  UpdateBlock = 'update-block',
  AcceptDiarizationCorrection = 'accept-diarization-correction',
  RejectDiarizationCorrection = 'reject-diarization-correction',

  // Server -> Client events
  ConnectionConfirmed = 'connection-confirmed',
  TranscriptionStarted = 'transcription-started',
  TranscriptionResult = 'transcription-result',
  TranscriptionError = 'transcription-error',
  TranscriptionPaused = 'transcription-paused',
  TranscriptionCompleted = 'transcription-completed',
  TranscriptionStopped = 'transcription-stopped',
  InconsistencyDetected = 'inconsistency-detected',
  BlockWavReady = 'block-wav-ready',
  BlockRemoved = 'block-removed',
  BlockUpdated = 'block-updated',
  SpeakerMapped = 'speaker-mapped',
  DiarizationCorrectionAvailable = 'diarization-correction-available',
  CorrectionProcessingComplete = 'correction-processing-complete',
}
